import createReducer from 'lib/createReducer';


const initialState = {
  isLoading: true,
  createPageViewerFail: false,
  pageBreakError: null
};

const actionHandlers = {
  ['CREATE_PAGE_VIEWER_FAIL']: (state, action) => {
    const { createPageViewerFail, isLoading } = action.data;

    return { createPageViewerFail, isLoading };
  },

  ['SET_ISLOADING']: (state, action) => {
    const { isLoading } = action.data;

    return { ...state, isLoading };
  },

  ['SET_PAGE_BREAK_ERROR']: (state, action) => {
    return { ...state, pageBreakError: action.data.message };
  },
};


export default createReducer(initialState, actionHandlers);
